import React from 'react';
export default function PayerSelect({value,onChange,label='Payer'}:{value:string,onChange:(value:string)=>void,label?:string}) {
 return <label style={{display:'block',color:'#8FA8C0',fontSize:12,fontWeight:700,marginBottom:16}}>{label}
  <select value={value} onChange={e=>onChange(e.target.value)} style={{display:'block',width:'100%',boxSizing:'border-box',marginTop:6,padding:'10px 12px',borderRadius:8,border:'1px solid #2D4259',background:'#243447',color:'#fff',fontSize:14}}>
   <option value="unknown">Choose Payer</option><option value="customer">Customer</option><option value="insurer">Insurer</option><option value="other">Other</option>
  </select>
 </label>;
}
